import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {
   email = '';
   password = '' ;
  //email;
  //password;


  constructor(private authService: AuthService, private router:Router) { }

  ngOnInit() {
  }

  onLogin() {

    this.authService.onLogin(this.email, this.password)
      .subscribe((result) => { 
        // check isLoggedIn$ then navigae to root if logggedIn
        if(this.authService.isLoggedIn$) { this.router.navigateByUrl('/')}      
        console.log(result)

      })
    
  }

}



// WEBPACK FOOTER //
// ./src/app/signin/signin.component.ts